
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><div class='qnumber'>{`1`}</div>{`Massnahmen`}</h3>
    <p>{`Schweden begeht in der Bekämpfung von Covid-19 einen Sonderweg: Statt auf staatliche Vor`}{`­`}{`schriften setzt man auf Eigen`}{`­`}{`verant`}{`­`}{`wortung. Zwar rät die Regierung ihren Bürgern wie in anderen Ländern zu `}<em parentName="p">{`Social Distancing`}</em>{` und zur Beachtung von Hygieneregeln – doch die Befolgung der Empfehlungen basiert weitgehend auf Frei`}{`­`}{`willigkeit.`}</p>
    <p>{`Die grössten Unterschiede zum Schweizer Lockdown: Die obligatorischen Schulen in Schweden blieben die ganze Zeit geöffnet, und das öffentliche Leben wurde nicht durch Versammlungs`}{`­`}{`verbote und die Schliessung von Läden, Cafés und Restaurants zum Erliegen gebracht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;